import { Link } from "react-router-dom";
import { DISPLAY_DOMAIN } from "../lib/brand";

const Logo = ({ size = "default", linkTo = "/" }) => {
  const sizes = {
    small: { img: "w-10 h-10", text: "text-lg", sub: "text-[10px]" },
    default: { img: "w-14 h-14", text: "text-xl", sub: "text-xs" },
    large: { img: "w-16 h-16", text: "text-2xl", sub: "text-sm" },
    xlarge: { img: "w-20 h-20", text: "text-3xl", sub: "text-sm" }
  };

  const s = sizes[size] || sizes.default;

  const LogoContent = () => (
    <div className="flex items-center gap-3">
      <img 
        src="/logo.png" 
        alt="EchoSense Capital Club" 
        className={`${s.img} object-contain`}
      />
      <div>
        <span className={`${s.text} font-semibold text-platinum font-serif tracking-wide`}>
          EchoSense Capital Club
        </span>
        <span className={`text-platinum/60 ${s.sub} block`}>{DISPLAY_DOMAIN}</span>
      </div>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center gap-3">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default Logo;
